import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  slas: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  slas: state => state.slas,

  getById: (state) => (id) => {
    return state.slas.find(sla => sla.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of slas.
   */
  getSlas ({ commit }, payload) {
    return http.get(`/slas/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_LIST] (state, slas) {
    state.slas = slas
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
